module.exports = __webpack_public_path__ + "static/Artboard-15-702c86107195d46089f74561ae38a3a3.png";